"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userIsPremium = function (user) {
    return !!(user === null || user === void 0 ? void 0 : user.isPremium);
};
exports.default = userIsPremium;
